import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangleDuotoneIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .12,
		d: "M1.59362 12.5657L7.07688 3.09464C7.37992 2.57119 7.53145 2.30947 7.72913 2.22157C7.90157 2.14489 8.09843 2.14489 8.27087 2.22157C8.46855 2.30947 8.62007 2.57119 8.92312 3.09463L14.4064 12.5657C14.7105 13.091 14.8626 13.3537 14.8401 13.5693C14.8205 13.7573 14.722 13.9282 14.5691 14.0394C14.3938 14.1668 14.0903 14.1668 13.4833 14.1668H2.51674C1.90973 14.1668 1.60622 14.1668 1.43091 14.0394C1.27801 13.9282 1.1795 13.7573 1.15989 13.5693C1.13742 13.3537 1.28948 13.091 1.59362 12.5657Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 6.50015V9.16682M8 11.8335H8.00667M7.07688 3.09464L1.59362 12.5657C1.28948 13.091 1.13742 13.3537 1.15989 13.5693C1.1795 13.7573 1.27801 13.9282 1.43091 14.0394C1.60622 14.1668 1.90973 14.1668 2.51674 14.1668H13.4833C14.0903 14.1668 14.3938 14.1668 14.5691 14.0394C14.722 13.9282 14.8205 13.7573 14.8401 13.5693C14.8626 13.3537 14.7105 13.091 14.4064 12.5657L8.92312 3.09463C8.62007 2.57119 8.46855 2.30947 8.27087 2.22157C8.09843 2.14489 7.90157 2.14489 7.72913 2.22157C7.53145 2.30947 7.37992 2.57119 7.07688 3.09464Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgAlertTriangleDuotoneIcon;
